var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 33,
    viewBox: "0 0 94 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2876 3.0629C31.8514 7.66997 28.3173 31.0979 25.2876 31.8422C19.2294 33.3307 1.05363 36.3081 0.0439429 18.445C-0.961468 0.657638 15.5218 -3.79163 25.2876 3.0629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C24 23.0751 23.0751 27 17 27C10.9249 27 10 23.0751 10 17C10 10.9249 10.9249 7 17 7C23.0751 7 24 10.9249 24 17Z",
    className: "Eyes"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7124 3.0629C62.1486 7.66997 65.6827 31.0979 68.7124 31.8422C74.7706 33.3307 92.9464 36.3081 93.9561 18.445C94.9615 0.657638 78.4782 -3.79163 68.7124 3.0629Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 17C84 23.0751 83.0751 27 77 27C70.9249 27 70 23.0751 70 17C70 10.9249 70.9249 7 77 7C83.0751 7 84 10.9249 84 17Z",
    className: "Eyes"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesA);
export default __webpack_public_path__ + "static/media/Eyes A.dd4f0f8880d5c40e3f1dfcc90d17161f.svg";
export { ForwardRef as ReactComponent };